export const COMPLIANCE_DISCLAIMER =
  "Crystal HACCP is a food-safety management and documentation platform. It supports businesses in organising HACCP procedures, records and operational checks based on their selected region and business information. Requirements can vary by country, authority, location and business type. Businesses remain responsible for confirming their obligations with the relevant authority or a qualified food-safety professional.";

export const SUPPORTED_REGIONS = [
  {
    code: "uk",
    name: "United Kingdom",
    note: "Food Standards Agency guidance and FHRS-style record keeping.",
  },
  {
    code: "us",
    name: "United States",
    note: "FDA Food Code aligned temperature and hygiene records.",
  },
  {
    code: "uae",
    name: "United Arab Emirates",
    note: "Dubai Municipality and UAE food-safety guidance.",
  },
  {
    code: "scandinavia",
    name: "Scandinavia, including Norway",
    note: "Mattilsynet-aligned internkontroll and temperature records.",
  },
] as const;

export const PLATFORM_FEATURES = [
  "Digital HACCP management",
  "Mobile food-safety inspections",
  "Temperature monitoring",
  "Cleaning and hygiene checks",
  "Corrective actions",
  "Incident reporting",
  "Compliance history",
  "Document management",
  "Regional law packs",
  "Multi-location management",
  "Staff roles and permissions",
  "Reports and inspection preparation",
  "Web and mobile synchronisation",
] as const;
